import React, { useEffect, useState } from 'react';
import theme from 'shared/theme';
import useAppState from 'state';
import useFirebase from 'vendor/Firebase';
import { IEmployeeDetails } from './types';
import {
  EmployeeDetails, EmployeeWrapper, EmployeePhoto, EmployeeName, EmployeeJobTitle,
} from './styledComponents';

const Employee = ({
  firstName, lastName, jobTitle, manager, owner, image,
}: IEmployeeDetails) => {
  const wrapperWidth = manager ? parseInt(theme.maxWidth, 10) / 2 : parseInt(theme.maxWidth, 10) / 3;

  const { configState } = useAppState();
  const { firebase } = useFirebase();
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    firebase.storage().ref(configState.storageRoot).child(image).getDownloadURL()
      .then((res: string) => {
        setImageUrl(res);
      });
  }, [image]);

  return (
    <EmployeeWrapper width={`${wrapperWidth}px`}>
      <EmployeePhoto isManager={manager} isOwner={owner} image={imageUrl} />
      <EmployeeDetails>
        <EmployeeName>
          {`${firstName} ${lastName}`}
        </EmployeeName>
        <EmployeeJobTitle>{jobTitle}</EmployeeJobTitle>
      </EmployeeDetails>
    </EmployeeWrapper>
  );
};

export default Employee;
